import { useAuth } from '../../hooks/useAuth';
import { WorkspaceSwitcher } from './WorkspaceSwitcher';

export function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="h-14 bg-surface-mid border-b border-border flex items-center justify-between px-6 fixed top-0 start-60 end-0 z-10">
      <WorkspaceSwitcher />

      <div className="flex items-center gap-4">
        {user && (
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-brand/20 flex items-center justify-center text-brand text-sm font-semibold">
              {user.name.charAt(0).toUpperCase()}
            </div>
            <div className="hidden sm:block">
              <p className="text-sm text-white leading-tight">{user.name}</p>
              <p className="text-xs text-slate-500">{user.email}</p>
            </div>
            <button
              onClick={() => logout()}
              className="text-slate-400 hover:text-white text-sm ms-2 transition-colors"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
